import { toQueryParams } from "utils/http/params";
import { authApi } from "./DataService";

const userApi = authApi
  .enhanceEndpoints({addTagTypes: ['users']})
  .injectEndpoints({
    endpoints: (builder) => ({

      getUsers: builder.query({
          query: (arg) => ({
              url: '/users',
              params: toQueryParams(arg)
          }),
          providesTags: ['users'] 
      }),

      getGrants: builder.query({
          query: (arg) => ({
              url: '/grants',
              params: toQueryParams(arg)
          }),
          providesTags: ['grants'] 
      }),

      updateUser: builder.mutation({
        query: ({id, body}) => ({
          url: `/users/${encodeURIComponent(id)}`,
          method: 'PATCH',
          body: body, 
        }),
        async onQueryStarted({body, id, cacheKey}, {dispatch, queryFulfilled}) {
          const result = dispatch(
            userApi.util.updateQueryData('getUsers', cacheKey, (draft) => {
              const index = draft?.body?.items.findIndex(el => el.id === id);
              if(index !== -1) { 
                draft.body.items[index] = {...draft.body.items[index], ...body};
              }
            })
          );
          try {
            await queryFulfilled;
          }
          catch {
            result.undo();
          }
        }
      }),

      addUser: builder.mutation({
        query: ({body}) => ({
          url: `/users`,
          method: 'POST',
          body: body, 
        }),
        async onQueryStarted({body, cacheKey}, {dispatch, queryFulfilled}) {
          const result = dispatch(
            userApi.util.updateQueryData('getUsers', cacheKey, (draft) => {
              draft.body.items.unshift({...body, id: -1});
            })
          );
          try {
            const { data } = await queryFulfilled;
            dispatch(
              userApi.util.updateQueryData('getUsers', cacheKey, (draft) => {
                const item = draft?.body?.items.find(el => el.name === data.body.name);
                item && Object.assign(item, data.body);
              })
            );
          }
          catch {
            result.undo();
          }
        }
      }),

      deleteUser: builder.mutation({
        query: ({id}) => ({
          url: `/users/${encodeURIComponent(id)}`,
          method: 'DELETE'
        }),
        async onQueryStarted({id, cacheKey}, {dispatch, queryFulfilled}) {
          const result = dispatch(
            userApi.util.updateQueryData('getUsers', cacheKey, (draft) => {
              const index = draft?.body?.items.findIndex(el => el.id === id);
              if(index !== -1) { 
                draft.body.items.splice(index, 1);
              }
            })
          );
          try {
            await queryFulfilled;
          }
          catch {
            result.undo();
          }
        }
      })

    })      
  });

  export const {
    useGetUsersQuery,
    useLazyGetUsersQuery,
    useGetGrantsQuery,
    useLazyGetGrantsQuery,
    useUpdateUserMutation,
    useAddUserMutation,
    useDeleteUserMutation
  } = userApi;